module.exports = __webpack_public_path__ + "img/CRC1_Myofibroblasts.a3a6cb67.png";